var exports = {
  "Sr": "Pagination.module__paginationBar___ZDZ6QU",
  "_s": "Pagination.module__paginationWrapper___ZDZ6QU",
  "gc": "Pagination.module__pageButton___ZDZ6QU",
  "Ks": "Pagination.module__pageButtonActive___ZDZ6QU",
  "oq": "Pagination.module__ellipsisButton___ZDZ6QU",
  "kh": "Pagination.module__pageInputForm___ZDZ6QU",
  "aW": "Pagination.module__pageInputLabel___ZDZ6QU",
  "AU": "Pagination.module__pageInput___ZDZ6QU",
  "Mp": "Pagination.module__focusRingCircular___ZDZ6QU",
};

module.exports = exports;
